import {
    FinancialDocumentPdfTemplateType,
    FinancialDocumentType,
    InvoiceReminderSendEmailParameters,
} from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { lt, showSuccessAlert } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import prefix from '../../prefix';

export interface SendBillsProps {
    financialDocumentId: string;
    financialDocumentType: FinancialDocumentType;
    emails: string[];
    language: string;
    printReason?: string;
    setShowPrintReason: (show: boolean) => void;
    template: FinancialDocumentPdfTemplateType;
    linkedBillIds?: string[];
}

export interface SendInvoiceProps {
    invoiceId: string;
    emails: string[];
    language: string;
    printReason?: string;
    setShowPrintReason: (show: boolean) => void;
    template: FinancialDocumentPdfTemplateType;
    linkedBillIds?: string[];
}

const SEND_FINANCIAL_DOCUMENT_TO_EMAILS = prefix('SEND_FINANCIAL_DOCUMENT_TO_EMAILS');

export const sendInvoiceReminder =
    ({
        invoiceId,
        emails,
        language,
        printReason,
        setShowPrintReason,
        template,
        linkedBillIds,
    }: SendInvoiceProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories, loggerService }) => {
        const payload: InvoiceReminderSendEmailParameters = {
            emails,
            invoiceId,
            linkedBillIds,
            printLanguageCode: language,
            printReason,
            templateType: template,
        };

        const promise = repositories.invoices.sendReminderEmails(payload).then(() => {
            showSuccessAlert({
                description: lt('EmailsSentSuccessfully'),
            });
            loggerService.log('send-invoice-reminder-to-emails', 'Sent invoice reminder to emails', {
                emails,
            });
            if (setShowPrintReason) setShowPrintReason(true);
        });

        return dispatch(createFetchAction(SEND_FINANCIAL_DOCUMENT_TO_EMAILS, promise));
    };

export const sendEmails =
    ({
        financialDocumentId,
        financialDocumentType,
        emails,
        language,
        printReason,
        setShowPrintReason,
        template,
        linkedBillIds,
    }: SendBillsProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories, loggerService }) => {
        const financialDoucmentIdCoproduct = {
            discriminator: financialDocumentType,
            value: financialDocumentId,
        };

        const payload = {
            financialDocumentId: financialDoucmentIdCoproduct,
            emails,
            printLanguageCode: language,
            printReason,
            templateType: template,
            linkedBillIds,
        };

        const promise = repositories.financialDocuments.sendEmails(payload).then(() => {
            showSuccessAlert({
                description: lt('EmailsSentSuccessfully'),
            });
            loggerService.log('send-financial-document-to-emails', 'Sent financial document to emails', {
                emails,
            });
            if (setShowPrintReason) setShowPrintReason(true);
        });

        return dispatch(createFetchAction(SEND_FINANCIAL_DOCUMENT_TO_EMAILS, promise));
    };
